import { render, staticRenderFns } from "./CharacterBonds.vue?vue&type=template&id=5c7161d8&"
import script from "./CharacterBonds.vue?vue&type=script&lang=js&"
export * from "./CharacterBonds.vue?vue&type=script&lang=js&"
import style0 from "./CharacterBonds.vue?vue&type=style&index=0&id=5c7161d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports